<template>
  <va-modal
    :value="showModal"
    ref="assignRolesModal"
    :okToClose="false"
    :noOutsideDismiss="false"
    :showOkay="false"
    size="large"
    :cancelText="$t('modals.buttons.back')"
    @cancel="closeAssignRolesModal"
  >
    <div slot="header" class="modal-title">
      <span>{{ $t('users.roles.assign_roles_to', {name: newUser.name}) }}</span>
    </div>

    <div v-if="!hasUserRoles">
      {{$t('users.roles.doesnt_have_roles')}}
      <br>
      <small>
        <b>
          {{ $t('users.roles.roles_description') }}
          <br>
          {{ $t('users.roles.roles_sub_description', {name: newUser.name}) }}
        </b>
      </small>
      <hr>
    </div>
    <user-role-details
      :userId="newUser.id"
      :entityId="newUser.entity_id"
      @userRolesUpdated="userRolesUpdated"
    />
  </va-modal>
</template>
<script>
import UserRoleDetails from '@/components/users/components/Roles/UserRoleDetails'
export default {
  components: {
    UserRoleDetails
  },
  props: {
    newUser: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hasUserRoles: false,
      showModal: false,
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    userRolesUpdated: function ({ serviceId }) {
      this.hasUserRoles = true
    },
    closeAssignRolesModal: function () {
      this.showModal = false
      setTimeout(() => {
        this.$emit('cancel')
      }, 500)
    }
  }
}
</script>

<style lang="scss">
.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}
</style>

<style scoped lang="scss">
ul {
  margin-bottom: 0.5rem;
}
</style>
